// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .label-form-container {
    padding: 1rem;
  }
}
.label-form-container .label-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.label-form-container .label-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.label-form-container .label-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modal-label-form-container {
  padding: 0rem !important;
  min-height: auto;
}

.label-form-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: label-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .label-form-card {
    padding: 1rem;
    width: 100%;
  }
}
.label-form-card .label-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .label-form-card .label-form-title {
    font-size: 1.25rem;
  }
}
.label-form-card .label-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.label-form-card .form-section {
  margin-bottom: 1.5rem;
}
.label-form-card .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.label-form-card .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.label-form-card .label-form-group,
.label-form-card .form-group {
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
}
.label-form-card .label-form-group:last-child,
.label-form-card .form-group:last-child {
  margin-bottom: 0;
}
.label-form-card .label-form-group .label-form-label,
.label-form-card .label-form-group label,
.label-form-card .form-group .label-form-label,
.label-form-card .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.label-form-card .label-form-group .label-form-label .label-form-required,
.label-form-card .label-form-group label .label-form-required,
.label-form-card .form-group .label-form-label .label-form-required,
.label-form-card .form-group label .label-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.label-form-card .label-form-input,
.label-form-card .label-form-form-select,
.label-form-card .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.label-form-card .label-form-input:focus,
.label-form-card .label-form-form-select:focus,
.label-form-card .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.label-form-card .label-form-input:hover:not(:focus),
.label-form-card .label-form-form-select:hover:not(:focus),
.label-form-card .custom-dropdown-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.label-form-card .label-form-input::placeholder,
.label-form-card .label-form-form-select::placeholder,
.label-form-card .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.label-form-card .label-form-input:disabled,
.label-form-card .label-form-form-select:disabled,
.label-form-card .custom-dropdown-input:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.label-form-card .label-form-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.label-form-card .label-form-flex-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .label-form-card .label-form-flex-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.label-form-card .label-form-flex-row .label-form-col-half {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-label .label-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input:focus,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input:hover:not(:focus),
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select:hover:not(:focus) {
  border-color: #9ca3af;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input::placeholder,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select::placeholder {
  color: #9ca3af;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input:disabled,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.label-form-card .case-selector {
  position: relative;
}
.label-form-card .case-selector .selected-cases-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  min-height: 2.5rem;
}
.label-form-card .case-selector .selected-cases-tags .case-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s ease;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.high-court {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.high-court:hover {
  background-color: #fde68a;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.district-court {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #3b82f6;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.district-court:hover {
  background-color: #bfdbfe;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.other-court {
  background-color: #f3e8ff;
  color: #7c3aed;
  border: 1px solid #8b5cf6;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.other-court:hover {
  background-color: #e9d5ff;
}
.label-form-card .case-selector .selected-cases-tags .case-tag button {
  background: none;
  border: none;
  color: currentColor;
  cursor: pointer;
  font-size: 1rem;
  padding: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 0.7;
  transition: all 0.2s ease;
}
.label-form-card .case-selector .selected-cases-tags .case-tag button:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.1);
}
.label-form-card .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.label-form-card .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.label-form-card .case-selector .dropdown-content .loading-state,
.label-form-card .case-selector .dropdown-content .no-results,
.label-form-card .case-selector .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.label-form-card .case-selector .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.label-form-card .case-selector .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.label-form-card .color-palette-container {
  width: 100%;
}
.label-form-card .color-palette-container .color-palette {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
  gap: 8px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  max-height: 300px;
  overflow-y: auto;
}
.label-form-card .color-palette-container .color-palette .color-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid transparent;
  transition: all 0.2s ease;
  position: relative;
}
.label-form-card .color-palette-container .color-palette .color-circle:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.label-form-card .color-palette-container .color-palette .color-circle.selected {
  border-color: #333;
  transform: scale(1.15);
}
.label-form-card .color-palette-container .color-palette .color-circle[style*=ffffff], .label-form-card .color-palette-container .color-palette .color-circle[style*=FFFFFF], .label-form-card .color-palette-container .color-palette .color-circle[style*=fafafa], .label-form-card .color-palette-container .color-palette .color-circle[style*=FAFAFA] {
  border: 1px solid #ddd;
}
.label-form-card .color-palette-container .selected-color-display {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}
.label-form-card .color-palette-container .selected-color-display .selected-color-preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.label-form-card .color-palette-container .selected-color-display .selected-color-code {
  font-family: monospace;
  font-weight: 500;
  color: #495057;
}
.label-form-card .color-picker .color-gradient {
  position: relative;
  height: 120px;
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e5e7eb;
}
.label-form-card .color-picker .color-gradient .selector-circle {
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: transparent;
  border: 2px solid #ffffff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.label-form-card .color-picker .color-controls {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.75rem;
}
.label-form-card .color-picker .color-controls .color-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px #e5e7eb;
  flex-shrink: 0;
}
.label-form-card .color-picker .color-controls .color-slider {
  flex-grow: 1;
  height: 20px;
  background: linear-gradient(to right, red, orange, yellow, green, cyan, blue, violet);
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  border: 1px solid #e5e7eb;
}
.label-form-card .color-picker .color-controls .color-slider .slider-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.label-form-card .label-form-button-container {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .label-form-card .label-form-button-container {
    flex-direction: column;
  }
}
.label-form-card .label-form-button-container .label-form-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .label-form-card .label-form-button-container .label-form-btn {
    width: 100%;
  }
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save {
  background-color: var(--primary-color);
  color: white;
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save:focus {
  outline: none;
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save:hover {
  background-color: #005a9a;
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.label-form-card .label-form-button-container .label-form-btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.label-form-card .label-form-button-container .label-form-btn-cancel:hover {
  background-color: #f8f9fa;
}

.modal-label-form-card {
  border: none;
  width: 100% !important;
}
.modal-label-form-card .modal-label-form-title {
  font-size: 1.3rem !important;
}

.client-modal-header .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}
.client-modal-header .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}

.exp-service-modal-body h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  text-align: center;
}
.exp-service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
  height: 2.5rem;
}
.exp-service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.exp-service-modal-body .new-service-input::placeholder {
  color: #9ca3af;
}
.exp-service-modal-body .submit-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transform: translateX(10.7rem);
}
.exp-service-modal-body .submit-btn:hover {
  background-color: #005a9a;
}
.exp-service-modal-body .submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

@keyframes label-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .label-form-container .label-form-card {
    width: 100%;
  }
  .color-palette-container .color-palette {
    grid-template-columns: repeat(auto-fill, minmax(35px, 1fr));
    gap: 6px;
  }
  .color-palette-container .color-palette .color-circle {
    width: 35px;
    height: 35px;
  }
}
/* MODIFICATION: ADDED STYLES FOR THE NEW "ADD PRIORITY" MODAL */
.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Higher z-index to appear above the main form modal */
  padding: 20px;
  box-sizing: border-box;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #e5e7eb;
  position: relative;
  animation: label-form-fade-in 0.2s ease-out; /* Re-using existing animation */
}
.confirmation-modal.notinvoice {
  width: 420px; /* Specific width for the small modal */
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.confirmation-actions.notinvoice {
  padding-top: 0; /* No extra padding needed for this simple modal */
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn:disabled,
.confirmation-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover:not(:disabled) {
  filter: brightness(95%);
}
.confirmation-actions .confirm-btn:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover:not(:disabled) {
  background: #4b5563;
}

.add-new-field-modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.add-new-field-modal-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: left;
  border-bottom: none; /* Override default h3 styling within the form */
  padding-bottom: 0;
}
.add-new-field-modal-content .add-new-field-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}
.add-new-field-modal-content .add-new-field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/forms/LabelForm/LabelForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAGE;EAXF;IAYI,aAAA;EAAF;AACF;AAIE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AAFJ;AAKI;EACE,yBAAA;EACA,cAAA;AAHN;AAOI;EACE,aAAA;EACA,6CAAA;AALN;;AAWA;EACE,wBAAA;EACA,gBAAA;AARF;;AAaA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,2CAAA;EACA,UAAA;AAVF;AAaE;EAVF;IAWI,aAAA;IACA,WAAA;EAVF;AACF;AAcE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAZJ;AAeI;EARF;IASI,kBAAA;EAZJ;AACF;AAiBE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAfJ;AAoBE;EACE,qBAAA;AAlBJ;AAqBI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAnBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AArBN;AA2BE;;EAEE,qBAAA;EACA,aAAA;EACA,sBAAA;AAzBJ;AA4BI;;EACE,gBAAA;AAzBN;AA6BI;;;;EAEE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAzBN;AA4BM;;;;EACE,cAAA;EACA,oBAAA;AAvBR;AA8BE;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA5BJ;AA+BI;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3BN;AA+BI;;;EACE,qBAAA;AA3BN;AA+BI;;;EACE,cAAA;AA3BN;AA+BI;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AA3BN;AAgCE;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA9BJ;AAmCE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAjCJ;AAoCI;EANF;IAOI,sBAAA;IACA,WAAA;EAjCJ;AACF;AAoCI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAlCN;AAqCM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAnCR;AAsCQ;EACE,cAAA;EACA,oBAAA;AApCV;AAyCM;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAvCR;AA0CQ;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAvCV;AA2CQ;;EACE,qBAAA;AAxCV;AA4CQ;;EACE,cAAA;AAzCV;AA6CQ;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AA1CV;AA+CM;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA7CR;AAoDE;EACE,kBAAA;AAlDJ;AAsDI;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AApDN;AAuDM;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AArDR;AAwDQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAtDV;AAyDU;EACE,yBAAA;AAvDZ;AA4DQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA1DV;AA6DU;EACE,yBAAA;AA3DZ;AAgEQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA9DV;AAiEU;EACE,yBAAA;AA/DZ;AAoEQ;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAlEV;AAqEU;EACE,UAAA;EACA,0CAAA;EACA,qBAAA;AAnEZ;AA2EI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AA1EN;AA6EM;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AA3ER;AA8EQ;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AA5EV;AA+EU;EACE,mBAAA;EACA,cAAA;AA7EZ;AAiFU;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AA/EZ;AAqFM;EACE,iBAAA;EACA,gBAAA;AAnFR;AAsFQ;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AApFV;AAuFU;EACE,mBAAA;AArFZ;AAyFU;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAvFZ;AA0FY;EACE,gBAAA;AAxFd;AA8FY;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA5Fd;AAgGY;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AA/Fd;AAmGY;EACE,kBAAA;EACA,cAAA;AAjGd;AAuGQ;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AArGV;AA0GM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAxGR;AA4GM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA1GR;AA6GQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AA3GV;AAoHE;EACE,WAAA;AAlHJ;AAqHI;EACE,aAAA;EACA,2DAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAnHN;AAsHM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AApHR;AAuHQ;EACE,qBAAA;EACA,wCAAA;AArHV;AAyHQ;EACE,kBAAA;EACA,sBAAA;AAvHV;AA6HQ;EAIE,sBAAA;AA9HV;AAoII;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAlIN;AAqIM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAnIR;AAuIM;EACE,sBAAA;EACA,gBAAA;EACA,cAAA;AArIR;AA6II;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA3IN;AA8IM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,wCAAA;AA5IR;AAiJI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA/IN;AAkJM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;AAhJR;AAoJM;EACE,YAAA;EACA,YAAA;EACA,qFAAA;EAQA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAzJR;AA4JQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,gCAAA;EACA,wCAAA;EACA,eAAA;AA1JV;AAkKE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAhKJ;AAmKI;EARF;IASI,sBAAA;EAhKJ;AACF;AAmKI;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjKN;AAoKM;EAXF;IAYI,WAAA;EAjKN;AACF;AAoKM;EACE,sCAAA;EACA,YAAA;AAlKR;AAqKQ;EACE,aAAA;AAnKV;AAqKQ;EACE,yBAAA;AAnKV;AAuKQ;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AArKV;AA4KI;EACI,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA1KR;AA6KQ;EACE,yBAAA;AA3KV;;AAkLA;EACE,YAAA;EACA,sBAAA;AA/KF;AAkLE;EACE,4BAAA;AAhLJ;;AAuLE;EA0BE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA7MJ;AAgNI;EACE,cAAA;EACA,yBAAA;AA9MN;;AA4NE;EAKE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AA7NJ;AAiOE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA/NJ;AAkOI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhON;AAoOI;EACE,cAAA;AAlON;AAuOE;EA8BE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AAlQJ;AAoQI;EACE,yBAAA;AAlQN;AAsQI;EACE,yBAAA;EACA,mBAAA;AApQN;;AA2QA;EACE;IACE,UAAA;IACA,2BAAA;EAxQF;EA4QA;IACE,UAAA;IACA,wBAAA;EA1QF;AACF;AA8QA;EACE;IACE,UAAA;IACA,2BAAA;EA5QF;EAgRA;IACE,UAAA;IACA,wBAAA;EA9QF;AACF;AAmRA;EACE,UAAA;AAjRF;;AAqRA;EACE,mBAAA;EACA,kBAAA;AAlRF;;AAsRA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAnRF;;AAuRA;EAGE,mBAAA;AAtRF;;AA2RA;EAEI;IACE,WAAA;EAzRJ;EA+RE;IACE,2DAAA;IACA,QAAA;EA7RJ;EAgSI;IACE,WAAA;IACA,YAAA;EA9RN;AACF;AAoSA,gEAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA,EAAA,uDAAA;EACA,aAAA;EACA,sBAAA;AAnSF;;AAsSA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA,EAAA,gCAAA;AAnSF;AAqSE;EACE,YAAA,EAAA,uCAAA;AAnSJ;;AAuSA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AApSF;AAsSE;EACE,cAAA,EAAA,kDAAA;AApSJ;AAuSE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AArSJ;AAuSI;;EACE,mBAAA;EACA,YAAA;AApSN;AAwSE;EACE,gCAAA;EACA,YAAA;AAtSJ;AAwSI;EACE,uBAAA;AAtSN;AAySI;EACE,yBAAA;EACA,cAAA;AAvSN;AA2SE;EACE,mBAAA;EACA,YAAA;AAzSJ;AA2SI;EACE,mBAAA;AAzSN;;AA+SA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5SF;AA8SE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA,EAAA,gDAAA;EACA,iBAAA;AA5SJ;AA+SE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AA7SJ;AA+SI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA7SN","sourcesContent":["// Main Container - Match ExpenseForm structure\n.label-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n\n  // Close button for modal\n  .label-form-close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    z-index: 1001;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #374151;\n    }\n\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}\n\n\n.modal-label-form-container {\n  padding: 0rem !important;\n  min-height: auto;\n}\n\n\n// Form Wrapper - Match ExpenseForm card structure\n.label-form-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  animation: label-form-fade-in 0.3s ease-out;\n  width: 70%;\n\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    width: 100%;\n  }\n\n\n  // Title styling\n  .label-form-title {\n    font-size: 1.3rem;\n    font-weight: 500;\n    color: #374151;\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n\n    @media (max-width: 768px) {\n      font-size: 1.25rem;\n    }\n  }\n\n\n  // Divider styling\n  .label-form-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n\n  // Form sections\n  .form-section {\n    margin-bottom: 1.5rem;\n\n\n    &:last-of-type {\n      border-bottom: none;\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n    }\n  }\n\n\n  // Form groups\n  .label-form-group,\n  .form-group {\n    margin-bottom: 0.5rem;\n    display: flex;\n    flex-direction: column;\n\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n\n    .label-form-label,\n    label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n\n\n      .label-form-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n  }\n\n\n  // Input and select styling\n  .label-form-input,\n  .label-form-form-select,\n  .custom-dropdown-input {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-family: inherit;\n    color: #374151;\n    background: #ffffff;\n    box-sizing: border-box;\n    height: 2.5rem;\n\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n\n\n    &:hover:not(:focus) {\n      border-color: #9ca3af;\n    }\n\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n\n\n    &:disabled {\n      background-color: #f9fafb;\n      color: #6b7280;\n      cursor: not-allowed;\n    }\n  }\n\n\n  .label-form-form-select {\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 0.5rem center;\n    background-repeat: no-repeat;\n    background-size: 1.5rem 1.5rem;\n    padding-right: 2.5rem;\n  }\n\n\n  // Two column layout for label form\n  .label-form-flex-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 0.5rem;\n\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n\n\n    .label-form-col-half {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n\n\n      .label-form-label {\n        display: block;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        font-size: 0.875rem;\n        color: #374151;\n\n\n        .label-form-required {\n          color: #ef4444;\n          margin-left: 0.25rem;\n        }\n      }\n\n\n      .label-form-input,\n      .label-form-form-select {\n        width: 100%;\n        padding: 0.5rem;\n        border: 1px solid #d1d5db;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        font-family: inherit;\n        color: #374151;\n        background: #ffffff;\n        box-sizing: border-box;\n        height: 2.5rem;\n\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n\n        &:hover:not(:focus) {\n          border-color: #9ca3af;\n        }\n\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n\n\n        &:disabled {\n          background-color: #f9fafb;\n          color: #6b7280;\n          cursor: not-allowed;\n        }\n      }\n\n\n      .label-form-form-select {\n        appearance: none;\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n        background-position: right 0.5rem center;\n        background-repeat: no-repeat;\n        background-size: 1.5rem 1.5rem;\n        padding-right: 2.5rem;\n      }\n    }\n  }\n\n\n  // Case Selector - Match ExpenseForm exactly\n  .case-selector {\n    position: relative;\n\n\n    // Selected cases tags\n    .selected-cases-tags {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.375rem;\n      margin-top: 0.75rem;\n      padding: 0.75rem;\n      background: #f9fafb;\n      border-radius: 0.375rem;\n      border: 1px solid #e5e7eb;\n      min-height: 2.5rem;\n\n\n      .case-tag {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.375rem;\n        padding: 0.375rem 0.75rem;\n        border-radius: 1rem;\n        font-size: 0.75rem;\n        font-weight: 500;\n        transition: all 0.2s ease;\n\n\n        &.high-court {\n          background-color: #fef3c7;\n          color: #92400e;\n          border: 1px solid #f59e0b;\n\n\n          &:hover {\n            background-color: #fde68a;\n          }\n        }\n\n\n        &.district-court {\n          background-color: #dbeafe;\n          color: #1e40af;\n          border: 1px solid #3b82f6;\n\n\n          &:hover {\n            background-color: #bfdbfe;\n          }\n        }\n\n\n        &.other-court {\n          background-color: #f3e8ff;\n          color: #7c3aed;\n          border: 1px solid #8b5cf6;\n\n\n          &:hover {\n            background-color: #e9d5ff;\n          }\n        }\n\n\n        button {\n          background: none;\n          border: none;\n          color: currentColor;\n          cursor: pointer;\n          font-size: 1rem;\n          padding: 0;\n          width: 18px;\n          height: 18px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 50%;\n          opacity: 0.7;\n          transition: all 0.2s ease;\n\n\n          &:hover {\n            opacity: 1;\n            background-color: rgba(255, 255, 255, 0.6);\n            transform: scale(1.1);\n          }\n        }\n      }\n    }\n\n\n    // Dropdown content\n    .dropdown-content {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      width: 100%;\n      background: #ffffff;\n      border: 1px solid #d1d5db;\n      border-radius: 0.375rem;\n      z-index: 1000;\n      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\n        0 10px 10px -5px rgba(0, 0, 0, 0.04);\n      margin-top: 0.25rem;\n      overflow: hidden;\n      animation: dropdown-fade-in 0.2s ease-out;\n\n\n      .dropdown-tabs {\n        display: flex;\n        background: #f9fafb;\n        border-bottom: 1px solid #e5e7eb;\n\n\n        button {\n          flex: 1;\n          padding: 0.75rem 1rem;\n          border: none;\n          background: transparent;\n          color: #6b7280;\n          font-weight: 500;\n          font-size: 0.875rem;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          border-bottom: 2px solid transparent;\n\n\n          &:hover {\n            background: #f3f4f6;\n            color: #374151;\n          }\n\n\n          &.active {\n            background: #ffffff;\n            color: #3b82f6;\n            font-weight: 600;\n            border-bottom-color: #3b82f6;\n          }\n        }\n      }\n\n\n      .dropdown-options {\n        max-height: 250px;\n        overflow-y: auto;\n\n\n        .dropdown-option {\n          padding: 0.75rem 1rem;\n          cursor: pointer;\n          border-bottom: 1px solid #f3f4f6;\n          transition: all 0.2s ease;\n\n\n          &:hover {\n            background: #f9fafb;\n          }\n\n\n          &.selected {\n            background: #eff6ff;\n            color: #1e40af;\n            border-left: 3px solid #3b82f6;\n\n\n            .case-parties {\n              font-weight: 600;\n            }\n          }\n\n\n          .case-info {\n            .case-parties {\n              font-weight: 500;\n              color: #374151;\n              font-size: 0.875rem;\n              margin-bottom: 0.25rem;\n              line-height: 1.4;\n            }\n\n\n            .case-ref {\n              font-size: 0.75rem;\n              color: #6b7280;\n              font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\n                \"Liberation Mono\", Menlo, monospace;\n              background: #f3f4f6;\n              padding: 0.125rem 0.375rem;\n              border-radius: 0.25rem;\n              display: inline-block;\n              margin-bottom: 0.25rem;\n            }\n\n\n            .case-number {\n              font-size: 0.75rem;\n              color: #9ca3af;\n            }\n          }\n        }\n\n\n        .no-data {\n          padding: 2rem 1rem;\n          text-align: center;\n          color: #6b7280;\n          font-style: italic;\n          font-size: 0.875rem;\n        }\n      }\n\n\n      .loading-state,\n      .no-results,\n      .empty-state {\n        padding: 2rem 1rem;\n        text-align: center;\n        color: #6b7280;\n        font-style: italic;\n        font-size: 0.875rem;\n      }\n\n\n      .loading-state {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n\n\n        &::before {\n          content: '';\n          width: 16px;\n          height: 16px;\n          border: 2px solid #e5e7eb;\n          border-top: 2px solid #3b82f6;\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n        }\n      }\n     \n    }\n  }\n\n\n  // Color Palette Container\n  .color-palette-container {\n    width: 100%;\n\n\n    .color-palette {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));\n      gap: 8px;\n      padding: 16px;\n      background-color: #f8f9fa;\n      border-radius: 8px;\n      border: 1px solid #e9ecef;\n      max-height: 300px;\n      overflow-y: auto;\n\n\n      .color-circle {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        cursor: pointer;\n        border: 3px solid transparent;\n        transition: all 0.2s ease;\n        position: relative;\n\n\n        &:hover {\n          transform: scale(1.1);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n        }\n\n\n        &.selected {\n          border-color: #333;\n          transform: scale(1.15);\n          // box-shadow: 0 0 0 2px #fff, 0 0 0 4px #333;\n        }\n\n\n        // Add a subtle border for very light colors\n        &[style*=\"ffffff\"],\n        &[style*=\"FFFFFF\"],\n        &[style*=\"fafafa\"],\n        &[style*=\"FAFAFA\"] {\n          border: 1px solid #ddd;\n        }\n      }\n    }\n\n\n    .selected-color-display {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-top: 12px;\n      padding: 8px;\n      background-color: #fff;\n      border-radius: 4px;\n      border: 1px solid #e9ecef;\n\n\n      .selected-color-preview {\n        width: 24px;\n        height: 24px;\n        border-radius: 4px;\n        border: 1px solid #ddd;\n      }\n\n\n      .selected-color-code {\n        font-family: monospace;\n        font-weight: 500;\n        color: #495057;\n      }\n    }\n  }\n\n\n  // Color Picker Styling\n  .color-picker {\n    .color-gradient {\n      position: relative;\n      height: 120px;\n      width: 100%;\n      margin-bottom: 1rem;\n      border-radius: 0.375rem;\n      overflow: hidden;\n      cursor: pointer;\n      border: 1px solid #e5e7eb;\n\n\n      .selector-circle {\n        position: absolute;\n        width: 16px;\n        height: 16px;\n        background-color: transparent;\n        border: 2px solid #ffffff;\n        border-radius: 50%;\n        transform: translate(-50%, -50%);\n        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n      }\n    }\n\n\n    .color-controls {\n      display: flex;\n      align-items: center;\n      margin-bottom: 1rem;\n      gap: 0.75rem;\n\n\n      .color-circle {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        border: 2px solid #ffffff;\n        box-shadow: 0 0 0 1px #e5e7eb;\n        flex-shrink: 0;\n      }\n\n\n      .color-slider {\n        flex-grow: 1;\n        height: 20px;\n        background: linear-gradient(to right,\n            red,\n            orange,\n            yellow,\n            green,\n            cyan,\n            blue,\n            violet);\n        border-radius: 10px;\n        position: relative;\n        cursor: pointer;\n        border: 1px solid #e5e7eb;\n\n\n        .slider-handle {\n          position: absolute;\n          width: 20px;\n          height: 20px;\n          background-color: #ffffff;\n          border-radius: 50%;\n          border: 2px solid #d1d5db;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n\n  // Form actions to match ExpenseForm\n  .label-form-button-container {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e5e7eb;\n\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n\n    .label-form-btn {\n      padding: 0.75rem 1.5rem;\n      border: none;\n      border-radius: 0.375rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      cursor: pointer;\n      min-width: 120px;\n      transition: all 0.2s ease;\n\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n\n      &.label-form-btn-save {\n        background-color: var(--primary-color);\n        color: white;\n\n\n        &:focus {\n          outline: none;\n        }\n        &:hover{\n          background-color: #005a9a;\n        }\n\n\n        &:disabled {\n          background-color: #d1d5db;\n          color: #9ca3af;\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n      }\n\n\n     \n    }\n    .label-form-btn-cancel {\n        padding: 8px 16px;\n        border: 1px solid #ddd;\n        background: white;\n        color: #666;\n        border-radius: 4px;\n        cursor: pointer;\n        font-size: 14px;\n\n\n        &:hover {\n          background-color: #f8f9fa;\n        }\n      }\n  }\n}\n\n\n.modal-label-form-card {\n  border: none;\n  width: 100% !important;\n\n\n  .modal-label-form-title {\n    font-size: 1.3rem !important;\n  }\n}\n\n\n// Modal styles\n.client-modal-header {\n  .close-cross {\n    // background: none;\n    // border: none;\n    // font-size: 1.5rem;\n    // color: #6b7280;\n    // cursor: pointer;\n    // padding: 0;\n    // width: 2rem;\n    // height: 2rem;\n    // display: flex;\n    // align-items: center;\n    // justify-content: center;\n    // border-radius: 0.25rem;\n    // transition: all 0.2s ease;\n\n\n    // &:hover {\n    //   color: #374151;\n    //   background-color: #f3f4f6;\n    // }\n\n\n    // &:focus {\n    //   outline: none;\n    //   box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    // }\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    padding: 0;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n\n\n    &:hover {\n      color: #374151;\n      background-color: #f3f4f6;\n    }\n  }\n}\n\n\n.exp-service-modal-body {\n  //padding: 1.5rem;\n  //justify-content: end;\n  // display: flex;\n  // flex-direction: column;\n  // align-items: flex-end;\n\n\n  h3 {\n    // font-size: 1.25rem;\n    // font-weight: 500;\n    // color: #374151;\n    // margin: 0 0 1rem 0;\n    font-size: 1rem;\n    font-weight: 500;\n    color: #374151;\n    margin: 0 0 1rem 0;\n    text-align: center;\n  }\n\n\n  .new-service-input {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    margin-bottom: 1rem;\n    box-sizing: border-box;\n    height: 2.5rem;\n\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n  }\n\n\n  .submit-btn {\n    // background-color: #16a34a;\n    // color: white;\n    // border: none;\n    // padding: 0.75rem 1.5rem;\n    // border-radius: 0.375rem;\n    // font-size: 0.875rem;\n    // font-weight: 500;\n    // cursor: pointer;\n    // min-width: 120px;\n    // transition: all 0.2s ease;\n\n\n    // &:hover:not(:disabled) {\n    //   background-color: #15803d;\n    // }\n\n\n    // &:focus {\n    //   outline: none;\n    //   box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\n    // }\n\n\n    // &:disabled {\n    //   background-color: #d1d5db;\n    //   color: #9ca3af;\n    //   cursor: not-allowed;\n    //   opacity: 0.6;\n    // }\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    transform: translateX(10.7rem);\n   \n    &:hover {\n      background-color: #005a9a;\n    }\n\n\n    &:disabled {\n      background-color: #9ca3af;\n      cursor: not-allowed;\n    }\n  }\n}\n\n\n// Animations\n@keyframes label-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n@keyframes dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n// Scrollbar styling for dropdown\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\n  width: 6px;\n}\n\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n  transition: background-color 0.2s ease;\n}\n\n\n.case-selector\n  .dropdown-content\n  .dropdown-options::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n\n// Responsive design improvements\n@media (max-width: 768px) {\n  .label-form-container {\n    .label-form-card {\n      width: 100%;\n    }\n  }\n\n\n  .color-palette-container {\n    .color-palette {\n      grid-template-columns: repeat(auto-fill, minmax(35px, 1fr));\n      gap: 6px;\n\n\n      .color-circle {\n        width: 35px;\n        height: 35px;\n      }\n    }\n  }\n}\n\n\n/* MODIFICATION: ADDED STYLES FOR THE NEW \"ADD PRIORITY\" MODAL */\n\n.confirmation-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050; /* Higher z-index to appear above the main form modal */\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.confirmation-modal {\n  background: #ffffff;\n  padding: 24px;\n  border-radius: 8px;\n  max-width: 95%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border: 1px solid #e5e7eb;\n  position: relative;\n  animation: label-form-fade-in 0.2s ease-out; /* Re-using existing animation */\n\n  &.notinvoice {\n    width: 420px; /* Specific width for the small modal */\n  }\n}\n\n.confirmation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n\n  &.notinvoice {\n    padding-top: 0; /* No extra padding needed for this simple modal */\n  }\n\n  .confirm-btn,\n  .cancel-btn {\n    padding: 8px 18px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 80px;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n\n  .confirm-btn {\n    background: var(--primary-color);\n    color: white;\n\n    &:hover:not(:disabled) {\n      filter: brightness(95%);\n    }\n\n    &:disabled {\n      background-color: #d1d5db;\n      color: #9ca3af;\n    }\n  }\n\n  .cancel-btn {\n    background: #6b7280;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #4b5563;\n    }\n  }\n}\n\n// Styles for the content within the new modal\n.add-new-field-modal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  h3 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n    text-align: left;\n    border-bottom: none; /* Override default h3 styling within the form */\n    padding-bottom: 0;\n  }\n\n  .add-new-field-input {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 14px;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
